import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="notfound">
      <h1 style={{ fontSize: "2.2rem", marginBottom: 12 }}>Page not found</h1>
      <p style={{ color: "var(--text-muted)", marginBottom: 24 }}>
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link to="/" className="btn btn-primary">
        Back to Home
      </Link>
    </div>
  );
}
